import React from "react";

function GoogleMap() {
	return (
		<iframe
			width="600"
			height="400"
			id="gmap_canvas"
			title="Harta - locatia centrului Rafiziomed"
			src="https://maps.google.com/maps?q=Rafiziomed&t=&z=15&ie=UTF8&iwloc=&output=embed"
			frameBorder="0"
			scrolling="no"
			marginWidth="0"
			marginHeight="0"
		></iframe>
	);
}

export default GoogleMap;
